module.exports = __webpack_public_path__ + "static/media/27OCHA10.4594e96c.jpg";